<template>
  <div>
    <!-- {{ selectedPermission }} -->
    <br />
    <!-- {{ selected }} -->
    <v-data-table
      v-model="selected"
      :headers="headersRole"
      :items="getPermissionsList"
      item-key="name"
      :show-select="showSelect"
      class="elevation-1"
      @toggle-select-all="selectAllToggle"
      disable-sort
      show-group-by
      group-by="screenName"
      disable-pagination
      hide-default-footer
      height="300px"
      dense
    >
      <template v-slot:group.header="{ group, headers, toggle, isOpen }">
        <td :colspan="headers.length">
          <v-btn @click="toggle" small icon :ref="group" :data-open="isOpen">
            <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
            <v-icon v-else>mdi-chevron-down</v-icon>
          </v-btn>
          <!-- <v-checkbox dense></v-checkbox> -->
          {{ group }}
        </td>
      </template>
      <!-- <template v-slot:header="{ props }">
        <v-checkbox dense></v-checkbox>
        Hello
      </template> -->
      <template v-slot:item.data-table-select="{ isSelected, select }">
        <v-simple-checkbox
          dense
          :value="isSelected"
          @input="select($event)"
          :ripple="false"
        ></v-simple-checkbox> </template
    ></v-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { permissions, permissionModuleList } from "../../utils/constant";

export default {
  name: "TempTable",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    showSelect: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      //   selected: [],
      disabledCount: 0,
      headersRole: [
        {
          text: "Module",
          value: "name",
          groupable: false,
          width: "200",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      tenantSettingTypes: "tenant/tenantSettingTypes",
      masterSettingTypes: "tenant/masterSettingTypes",
    }),
    selected: {
      get() {
        return this.value.map((value) =>
          this.getPermissionsList.find((option) => option.id === value)
        );
      },
      set(values) {
        const data = values.map((value) => value.id);
        this.$emit("input", data || []);
      },
    },
    getPermissionsList() {
      let data = this.masterSettingTypes("permissions").filter((data) =>
        permissionModuleList.find((value) => data.id === value)
      );

      return data.map((obj) => ({
        ...obj,
        isSelected: false,
      }));
    },
  },
  methods: {
    selectAllToggle(props) {
      props.items.forEach((item) => {
        item.isSelected = props.value;
      });
    },
  },
};
</script>

<style scoped>
::v-deep .v-data-table tbody tr.v-data-table__selected {
  background: none;
}
</style>